module.exports = __webpack_public_path__ + "static/media/wine-beer.55978911.png";